import React from "react";

const AwaitingApproval = ({
  isAwaitingApprovalOpen,
  closeAwaitingApproval,
}) => {
  if (!isAwaitingApprovalOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-10">
      <div className="bg-white rounded-sm shadow-xl w-[670px] h-[340px] flex flex-col items-center justify-center p-8 text-center">
        <div className="mb-6 flex items-center justify-center w-[76px] h-[76px] rounded-full bg-blue-100">
          <div className="bg-blue-100 p-3 rounded-full">
            <img
              src="/blue-tick.png"
              alt="Awaiting Approval"
              className="w-12 h-12"
            />
          </div>
        </div>

        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Loan Application Successful!
        </h2>
        <p className="text-gray-600 text-sm mb-6">
          The loan application has been submitted successfully and is now
          pending approval.
        </p>

        <button
          onClick={closeAwaitingApproval}
          className="bg-[#074073] hover:bg-[#052f5a] text-white py-2 px-8 rounded-md font-medium transition-colors"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default AwaitingApproval;
